export const codeToCountry = (code) => {
  const countryMap = {
    '+1': 'US',
    '+52': 'MX',
    '+56': 'CL',
    '+593': 'EC',
    '+81': 'JP',
  };

  return countryMap[code] || 'US';
};
